import React, { useState } from 'react';
import styles from './UIGameEndContent.module.scss';
import clsx from 'clsx';
import { DevCardStats, DiceStats, Overview, ResourceCardStats, ActivityStats, ResourceStats } from './tabs/index.ts';
import { PlayerTable } from './PlayerTable/index.ts';
import { useUIGameEndContext } from '../../../contexts/UIGameEndContext.tsx';
import { T } from '@colonist/ui';
import { FADE_IN_ANIMATION_DELAYS } from '../constants.ts';
import { AudioManager, AudioType } from '@colonist/audio';
import { FadeInContainer } from '../../../common/FadeInContainer/index.ts';
import { useGameStore } from '../../../store/GameStoreContext.ts';
import { useIsReplay } from '../../../store/selectors/useIsReplay.ts';
const TAB_CONTENT_MAP = {
    overview: /*#__PURE__*/ React.createElement(Overview, null),
    diceStats: /*#__PURE__*/ React.createElement(DiceStats, null),
    resCardStats: /*#__PURE__*/ React.createElement(ResourceCardStats, null),
    devCardStats: /*#__PURE__*/ React.createElement(DevCardStats, null),
    activityStats: /*#__PURE__*/ React.createElement(ActivityStats, null),
    resourceStats: /*#__PURE__*/ React.createElement(ResourceStats, null)
};
export const Tabs = ({ tabs, selected, onTabClick })=>/*#__PURE__*/ React.createElement("div", {
        className: styles.tabs
    }, tabs.map((tab)=>/*#__PURE__*/ React.createElement("div", {
            className: clsx(styles.tab, {
                [styles.active]: selected === tab.id
            }),
            key: tab.id,
            onClick: ()=>{
                onTabClick(tab);
                AudioManager.play(AudioType.Click);
            }
        }, /*#__PURE__*/ React.createElement(T, {
            id: tab.label
        }))));
export const UIGameEndContent = ({ disableAnimation })=>{
    const { isPlayerHasRankedState } = useUIGameEndContext();
    const isReplay = useIsReplay();
    const translationKeyContext = useGameStore((state)=>state.gameMode.translationKeyContext);
    const TAB_DATA_OVERVIEW = {
        id: 'overview',
        label: {
            key: 'strings:game.endGame.overview.title'
        }
    };
    const TAB_DATA_DICE_STATS = {
        id: 'diceStats',
        label: {
            key: 'strings:game.endGame.dice.title'
        }
    };
    const TAB_DATA_RESOURCE_CARD_STATS = {
        id: 'resCardStats',
        label: {
            key: 'strings:game.endGame.resourceCards.title'
        }
    };
    const TAB_DATA_DEV_CARD_STATS = {
        id: 'devCardStats',
        label: {
            key: 'strings:game.endGame.devCards.title',
            options: {
                context: translationKeyContext
            }
        }
    };
    const TAB_DATA_ACTIVITY_STATS = {
        id: 'activityStats',
        label: {
            key: 'strings:game.endGame.activity.title'
        }
    };
    const TAB_DATA_RESOURCE_STATS = {
        id: 'resourceStats',
        label: {
            key: 'strings:game.endGame.resource.title'
        }
    };
    const TOP_TAB_DATA = [
        TAB_DATA_OVERVIEW,
        TAB_DATA_ACTIVITY_STATS,
        TAB_DATA_RESOURCE_STATS
    ];
    const BOTTOM_TAB_DATA = [
        TAB_DATA_DICE_STATS,
        TAB_DATA_RESOURCE_CARD_STATS,
        TAB_DATA_DEV_CARD_STATS
    ];
    const ALL_TAB_DATA = [
        TAB_DATA_OVERVIEW,
        TAB_DATA_DICE_STATS,
        TAB_DATA_RESOURCE_CARD_STATS,
        TAB_DATA_DEV_CARD_STATS,
        TAB_DATA_ACTIVITY_STATS,
        TAB_DATA_RESOURCE_STATS
    ];
    const [selectedTab, setSelectedTab] = useState(ALL_TAB_DATA[0].id);
    const [selectedTopTab, setSelectedTopTab] = useState(TOP_TAB_DATA[0].id);
    const [selectedBottomTab, setSelectedBottomTab] = useState(BOTTOM_TAB_DATA[0].id);
    const handleTabClick = (tab)=>{
        setSelectedTab(tab.id);
    };
    const handleTopTabClick = (tab)=>{
        setSelectedTopTab(tab.id);
    };
    const handleBottomTabClick = (tab)=>{
        setSelectedBottomTab(tab.id);
    };
    return /*#__PURE__*/ React.createElement(FadeInContainer, {
        animationDelayMs: isPlayerHasRankedState && !isReplay ? FADE_IN_ANIMATION_DELAYS.contentRankedGame : FADE_IN_ANIMATION_DELAYS.content,
        animationDurationMs: FADE_IN_ANIMATION_DELAYS.transitionDuration,
        className: clsx(styles.contentContainer),
        disableAnimation: disableAnimation
    }, /*#__PURE__*/ React.createElement("div", {
        className: styles.scaleContainer
    }, /*#__PURE__*/ React.createElement("div", {
        className: styles.allTabsContainer
    }, /*#__PURE__*/ React.createElement(Tabs, {
        onTabClick: (tab)=>handleTabClick(tab),
        selected: selectedTab,
        tabs: ALL_TAB_DATA
    }), /*#__PURE__*/ React.createElement("div", {
        className: styles.tabContent
    }, /*#__PURE__*/ React.createElement(PlayerTable, null), TAB_CONTENT_MAP[selectedTab])), /*#__PURE__*/ React.createElement("div", {
        className: styles.topTabsContainer
    }, /*#__PURE__*/ React.createElement(Tabs, {
        onTabClick: (tab)=>handleTopTabClick(tab),
        selected: selectedTopTab,
        tabs: TOP_TAB_DATA
    }), /*#__PURE__*/ React.createElement("div", {
        className: styles.tabContent
    }, /*#__PURE__*/ React.createElement(PlayerTable, null), TAB_CONTENT_MAP[selectedTopTab])), /*#__PURE__*/ React.createElement("div", {
        className: styles.bottomTabsContainer
    }, /*#__PURE__*/ React.createElement(Tabs, {
        onTabClick: (tab)=>handleBottomTabClick(tab),
        selected: selectedBottomTab,
        tabs: BOTTOM_TAB_DATA
    }), /*#__PURE__*/ React.createElement("div", {
        className: styles.tabContent
    }, TAB_CONTENT_MAP[selectedBottomTab]))));
};
